import { IErrorMessage } from '@hooks/use-error-message.ts';

export const productCategoriesErrorMessages: IErrorMessage = {
  name: {
    required: 'validation_name_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  description: {
    required: 'validation_description_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  }
};
